<template>
  <div
      class="listing-item bg-white shadow rounded overflow-hidden border border-gray200"
      style="width:100%"
      :id="`listing-${listing.id}`"
  >
    <a :href="`/brokerage-listings/${listing.id}`" class="listing-item-header cursor-pointer">
      <div class="listing-item-header-images">
        <div
            :style="{ backgroundImage: `url(${imageUrl})` }"
            class="bg-center bg-cover h-48"
        ></div>
      </div>
    </a>

    <div class="listing-item-details-wrapper">
      <a :href="`/brokerage-listings/${listing.id}`" class="listing-item-details cursor-pointer">
        <!-- Type / Status label -->
        <div class="listing-item-type">
          <div class="absolute pin opacity-40 rounded-b bg-green500"></div>
          <div class="relative">
            {{ venueTypeLabel }}
          </div>
        </div>

        <div class="listing-item-details-top">
          <!-- Price Row -->
          <div class="flex items-center">
            <span class="icon-m-land text-green500"></span>
            <div class="ml-15 text-xl text-gray700 font-secondary font-bold">
              {{ priceDisplay }}
            </div>
          </div>

          <!-- Title -->
          <div class="mt-20 text-lg font-bold text-gray700 leading-snug">
            {{ listing.title }}
          </div>

          <!-- Address -->
          <div class="mt-10">
            <div class="font-bold text-gray700">
              {{ formattedStreet || 'Address Unavailable' }}
            </div>
            <div class="mt-5 text-sm text-gray600">
              {{ formattedCityState }}
            </div>
          </div>
        </div>

        <!-- Bottom meta -->
        <div class="listing-item-details-bottom">
          <div class="py-30 px-30 flex flex-wrap">
            <div v-if="listing.squareFootage" class="flex px-20 items-center">
              <span class="icon-m-measure text-gray300"></span>
              <div class="listing-info-item ml-10 text-gray500">
                {{ listing.squareFootage.toLocaleString() }} sf
              </div>
            </div>
            <div v-else class="flex px-20 items-center">
              <span class="icon-m-measure text-gray300"></span>
              <div class="listing-info-item ml-10 text-gray500">
                Undisclosed sf
              </div>
            </div>
            <div v-if="listing.acres" class="flex px-20 items-center">
              <span class="icon-m-tree text-gray300"></span>
              <div class="listing-info-item ml-10 text-gray500">
                {{ listing.acres }} acres
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
// Renders one Algolia brokerage search hit as a linked result card.
export default {
  props: {
    listing: {
      type: Object,
      required: true
    }
  },
  computed: {
    venueTypeLabel() {
      const venue = this.listing.typeOfVenue?.label;
      const status = this.listing.propertyStatus?.label;
      return [venue, status].filter(Boolean).join(' • ');
    },
    formattedStreet() {
      const street1 = this.listing.address?.street1 || '';
      const street2 = this.listing.address?.street2 || '';
      return [street1, street2].filter(Boolean).join(' ');
    },
    formattedCityState() {
      const city = this.listing.address?.city || '';
      const state = this.listing.address?.state || '';
      const zip = this.listing.address?.zip || '';
      return [city, state, zip].filter(Boolean).join(', ');
    },
    priceDisplay() {
      if (this.listing.callForPricing) return 'Call for Pricing';
      if (this.listing.price) return `$${Number(this.listing.price).toLocaleString()}`;
      return 'Undisclosed Price';
    },
    imageUrl() {
      if (this.listing.image) {
        return this.listing.image;
      }

      const type = this.listing.typeOfVenue?.value || 'restaurant';
      return `/assets/img/brokerageListings/${type}.png`;
    },
  }
};
</script>
